/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const SpeedFast = (props: IconProps) => (
  <Icon {...props}>
    <path d="M16.2553 4.94796C14.9641 4.33991 13.5218 4 12 4C6.47715 4 2 8.47715 2 14C2 15.5368 2.34666 16.9926 2.96605 18.2935C3.50684 19.4294 4.73945 20 5.99746 20H18.0025C19.2606 20 20.4932 19.4294 21.034 18.2935C21.6533 16.9926 22 15.5368 22 14C22 11.8316 21.3098 9.82441 20.1372 8.1861L18.9387 10.0155C19.6138 11.1886 20 12.5492 20 14C20 15.2331 19.7224 16.3957 19.2282 17.4338C19.1119 17.6781 18.7315 18 18.0025 18H5.99746C5.26855 18 4.88815 17.6781 4.77182 17.4338C4.2776 16.3957 4 15.2331 4 14C4 9.58172 7.58172 6 12 6C12.7584 6 13.4922 6.10554 14.1875 6.30275L16.2553 4.94796Z" />
    <path d="M18.253 6.76777L12.9056 14.9297C12.1989 16.0082 10.6796 16.1648 9.76777 15.253C8.85598 14.3413 9.01257 12.8219 10.0912 12.1152L18.253 6.76777Z" />
  </Icon>
);
